import * as yup from "yup";

export const schema = yup.object().shape({
  category_id: yup.number().notRequired().nullable(),
  section_id: yup.number().notRequired().nullable(),
});
